export enum EmailStatus {
  SENT = 'Enviado',
  SCHEDULED = 'Envio programado',
  CANCELLED = 'Cancelado',
  PartialFailure = 'Houve falhas no envio',
  SendFailure = 'Falha ao enviar',
  DeliveryFailure = 'Falha no envio'
}
